import Quote from 'finviz-charts/app/models/quote'

import { convertTa } from '../../../app/charts-lib'
import { ObjectHash } from '../../components/types'
import { getInstrumentForTicker } from '../../util'

const PADDING = 2 // Border widths

export function getChartsDimensions(chartElementId: string) {
  const containerElement = document.getElementById(chartElementId)

  const box = containerElement?.getBoundingClientRect()

  return {
    width: Math.max((box?.width ?? 0) - PADDING, 0),
    height: Math.max((box?.height ?? 0) - PADDING, 0),
  }
}

export function getChartConfig(idea: any, chartElementId: string) {
  const chartsDimensions = getChartsDimensions(chartElementId)

  if (idea) {
    const chartConfig = Object.assign({}, FinvizChartsSettings.ideaChart, {
      colors: FinvizChartsSettings.colors,
      width: chartsDimensions.width,
      height: chartsDimensions.height,
      scrollable: true,
      editors: ['layout', 'settings', 'publish', 'tools'],
    })
    for (let i = 0; i < chartConfig.charts.length; i++) {
      if (!chartConfig.charts[i].instrument) {
        chartConfig.charts[i].instrument = 'stock'
      }
    }

    return chartConfig
  }

  return {
    newCharts: true,
    width: chartsDimensions.width,
    height: chartsDimensions.height,
    barWidth: 3,
    barMargin: 1,
    scrollable: true,
    alignChartsToRight: true,
    theme: FinvizChartsSettings.theme,
    colors: FinvizChartsSettings.colors,
    editors: ['layout', 'settings', 'publish', 'tools'],
    layout: FinvizChartsSettings.layout,
    charts: FinvizChartsSettings.tickers.map(function (ticker: string, index: number) {
      return {
        timeframe: FinvizChartsSettings.periods[index],
        dateRange: FinvizChartsSettings.ranges[index],
        scale: FinvizChartsSettings.taConfig.scale || 'linear',
        ticker: ticker,
        instrument: getInstrumentForTicker(ticker),
        premarket: FinvizChartsSettings.taConfig.premarket,
        aftermarket: FinvizChartsSettings.taConfig.aftermarket,
        hasChartEvents: FinvizChartsSettings.taConfig.hasChartEvents,
        refreshData: true,
        panes: convertTa.getPanes(FinvizChartsSettings.taConfig),
      }
    }),
  }
}

export const initIdeaQuotes = (quotes: Array<ObjectHash>, ideaChart: ObjectHash) => {
  const hasPatterns = JSON.stringify(ideaChart).includes('patterns')

  for (let i = 0; i < quotes.length; i++) {
    const quote = quotes[i]

    if (quote.timeframe === 'i1' || quote.timeframe === 'i3' || quote.timeframe === 'i5' || quote.timeframe === 'i15') {
      if (!quote.hasOwnProperty('drawMinutesPerDay')) {
        quote.drawMinutesPerDay = quote.timeframe === 'i15' ? 390 : 420
      }

      if (!quote.hasOwnProperty('marketStartMinutes')) {
        quote.marketStartMinutes = quote.timeframe === 'i15' ? 570 : 540
      }

      if (!quote.hasOwnProperty('premarketLengthMinutes')) {
        quote.premarketLengthMinutes = quote.timeframe === 'i15' ? 0 : 30
      }

      if (!quote.hasOwnProperty('aftermarketLengthMinutes')) {
        quote.aftermarketLengthMinutes = 0
      }
    }

    if (!quote.hasOwnProperty('hasPatterns')) {
      quote.hasPatterns = hasPatterns
    }

    quote.ideaID = ideaChart.idea.id

    Quote.create<Quote>(quote)
  }
}
